import Axios from "axios";
const IMAGE_URL = location.origin;

export default async (src)=> {
    let res = await Axios.get(IMAGE_URL + "/" + src, {
      responseType: "text",
    });
    return res.data;
  }